export enum NoteTypeSlugs {
  MEMBER_AVAILABILITY = 'member-availability'
}
